import { jsx as _jsx } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { Button } from '../../../../../infra/dls/components/button/button';
import ArrowLeftIcon from '../../icons/arrow-left.svg';
import { usePortalNode } from '../../../hooks/use-portal-node';
import { useBreakpoints } from '../../../../../infra/dls/hooks/use-get-breakpoints';
import { IconButton } from '../../../../../infra/dls/components/icon-button/icon-button';
import { t } from '../../../../../infra/i18n';
export var NextStepButton = function (_a) {
    var onClick = _a.onClick, children = _a.children;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var mobileNode = usePortalNode('mobile-next-step-portal');
    var desktopNode = usePortalNode('desktop-next-step-portal');
    var automationId = 'button:nextStep';
    if (isMobileOrSmaller) {
        if (!mobileNode) {
            return null;
        }
        return createPortal(_jsx(Button, { onClick: onClick, variant: "primary", fullWidth: true, "data-automation-id": automationId, children: children }), mobileNode);
    }
    if (!desktopNode) {
        return null;
    }
    return createPortal(_jsx(Button, { onClick: onClick, variant: "primary", "data-automation-id": automationId, children: children }), desktopNode);
};
export var PreviousStepButton = function (_a) {
    var onClick = _a.onClick;
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var mobileNode = usePortalNode('mobile-previous-step-portal');
    var desktopNode = usePortalNode('desktop-previous-step-portal');
    var automationId = 'button:previousStep';
    if (isMobileOrSmaller) {
        if (!mobileNode) {
            return null;
        }
        return createPortal(_jsx(IconButton.XL, { Icon: _jsx(ArrowLeftIcon, {}), onClick: onClick, "data-automation-id": automationId }), mobileNode);
    }
    if (!desktopNode) {
        return null;
    }
    return createPortal(_jsx(Button, { onClick: onClick, variant: "secondary", "data-automation-id": automationId, children: t('engage:campaign_builder.header.back') }), desktopNode);
};
